import GuestMixin from './GuestMixin';

export default {
    mixins: [GuestMixin],
    data() {
        return {
            afterSubscribeActionFail: null,
            afterSubscribeAction: 'updateRoute',
            showSubscribeModal: false,
        }
    },
    methods: {
        closeSubscribeModal() {
            this.showSubscribeModal = false;
        },
        subscribed(email, phone) {
            this.showSubscribeModal = false;

            this.setGuest(email, phone).then(() => {
                if (this.afterSubscribeAction) {
                    this[this.afterSubscribeAction]()
                }
            }).catch(() => {
                if (this.afterSubscribeActionFail) {
                    this[this.afterSubscribeActionFail]()
                }
            });

        },
    }
}
